import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactModal from "react-modal";
import ProgramacionHoraria from "./ProgramacionHoraria";
import EditarProgramacionHoraria from "./EditarProgramacion";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Cookies from "universal-cookie";

function InfoProgramacionHoraria({ idEvaluador, idSolicitud, EsLider }) {
  const cookie = new Cookies();

  const [modalIsOpen, setIsOpen] = useState(false);
  const [list, setList] = useState([]);
  const [evaluadores, setEvaluadores] = useState([]);
  const [evaluadorSeleccionado, setEvaluadorSeleccionado] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingPdf, setLoadingPdf] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const auth = {
    username: "BasicAuth@icontec.org",
    password: "yQLzqmR7eZSuAmQZUqhY",
  };

  const esLider = EsLider === true || EsLider == "LIDER";

  const fetchData = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerProgramacion/${idEvaluador}/${idSolicitud}`,
        {
          auth,
        },
      );

      setList(data || []);
    } catch (error) {
      console.error("Error cargando programación", error);
    }
  }, [idEvaluador, idSolicitud]);

  const fetchEvaluadores = useCallback(async () => {
    if (!esLider) {
      return;
    }

    try {
      const { data } = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/QEquipoUsuario?SolicitudId=${idSolicitud}`,
        {
          auth,
        },
      );

      const lista = data || [];

      setEvaluadores(lista);

      if (lista.length > 0) {
        const evaluadorActual = lista.find(
          (item) => Number(item.evaluadorId) === Number(idEvaluador),
        );

        if (evaluadorActual) {
          setEvaluadorSeleccionado(evaluadorActual.evaluadorId);
        } else {
          setEvaluadorSeleccionado(lista[0].evaluadorId);
        }
      } else {
        setEvaluadorSeleccionado("");
      }
    } catch (error) {
      console.error("Error cargando evaluadores", error);
      setEvaluadores([]);
      setEvaluadorSeleccionado("");
    }
  }, [idSolicitud, idEvaluador, esLider]);

  useEffect(() => {
    if (modalIsOpen) {
      fetchData();

      if (esLider) {
        fetchEvaluadores();
      }
    }
  }, [modalIsOpen, fetchData, fetchEvaluadores, esLider]);

  const filteredList = useMemo(() => {
    return list.filter((item) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [list, searchTerm]);

  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  const currentItems = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;

    return filteredList.slice(start, start + itemsPerPage);
  }, [filteredList, currentPage]);

  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(1);
    }
  }, [filteredList, totalPages, currentPage]);

  const formatDate = (date) => date?.split("T")[0];

  const formatTime = (value) => {
    const d = new Date(value);

    return isNaN(d)
      ? value
      : d.toLocaleTimeString("es-CO", {
          hour: "2-digit",
          minute: "2-digit",
        });
  };

  const generarPdf = async () => {
    const evaluadorId = esLider ? evaluadorSeleccionado : cookie.get("id");

    if (!evaluadorId) {
      alert("No se encontró el evaluador para generar el PDF.");
      return;
    }

    try {
      setLoadingPdf(true);

      const response = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/GenerarPdfProgramacion/${evaluadorId}/${idSolicitud}`,
        {
          auth,
          responseType: "blob",
        },
      );

      const pdfBlob = new Blob([response.data], {
        type: "application/pdf",
      });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      window.open(pdfUrl, "_blank");

      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
      }, 10000);
    } catch (error) {
      console.error("Error generando PDF", error);
      alert("No fue posible generar el PDF.");
    } finally {
      setLoadingPdf(false);
    }
  };

  return (
    <Fragment>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="tooltip-horario">
            Información de la programación Horaria
          </Tooltip>
        }
      >
        <button className="btn btn-dark" onClick={() => setIsOpen(true)}>
          P.Horaria
        </button>
      </OverlayTrigger>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        ariaHideApp={false}
      >
        <div className="container">
          <h5 className="text-primary text-center mb-3">P. HORARIA</h5>

          <center>
            <DatePicker selected={startDate} onChange={setStartDate} inline />
          </center>

          <hr />

          <ProgramacionHoraria
            idS={idSolicitud}
            idE={idEvaluador}
            onCreate={() => {
              fetchData();
              setCurrentPage(1);
            }}
          />
          <div className="row align-items-end">
            {esLider && (
              <div className="col-md-8">
                <label className="form-label">Evaluador</label>

                <select
                  className="form-control"
                  value={evaluadorSeleccionado}
                  onChange={(e) => setEvaluadorSeleccionado(e.target.value)}
                >
                  <option value="">Seleccione un evaluador</option>

                  {evaluadores.map((evaluador) => (
                    <option key={evaluador.id} value={evaluador.evaluadorId}>
                      {evaluador.nombreRol} - {evaluador.nombre}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className={esLider ? "col-md-4" : "col-md-12"}>
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={generarPdf}
                disabled={
                  loadingPdf ||
                  (esLider &&
                    (!evaluadorSeleccionado || evaluadores.length === 0))
                }
              >
                {loadingPdf ? "Generando PDF..." : "Generar PDF"}
              </button>
            </div>
          </div>
          <input
            className="form-control my-3"
            placeholder="Buscar..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
          />

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Fecha</th>
                  <th>Servicio</th>
                  <th>Horario</th>
                  <th>Actividad</th>
                  <th>Cumplimiento</th>
                  <th>Observaciones</th>
                  <th>Evaluador</th>
                  <th>Editar</th>
                </tr>
              </thead>

              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{formatDate(item.fecha)}</td>
                      <td>{item.servicio}</td>
                      <td>{formatTime(item.horario)}</td>
                      <td>{item.actividad}</td>
                      <td>{item.cumplimiento}</td>
                      <td>{item.observaciones}</td>
                      <td>{item.nombreEvaluador}</td>

                      <td>
                        <EditarProgramacionHoraria
                          idEvento={item.id}
                          datosActuales={item}
                          onUpdate={() => {
                            fetchData();
                          }}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      Sin resultados
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-center mt-3">
            <ul className="pagination">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  disabled={currentPage === 1}
                >
                  Anterior
                </button>
              </li>

              {[...Array(totalPages)].map((_, index) => (
                <li
                  key={index}
                  className={`page-item ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}

              <li
                className={`page-item ${
                  currentPage === totalPages || totalPages === 0
                    ? "disabled"
                    : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Siguiente
                </button>
              </li>
            </ul>
          </div>

          <hr />
        </div>
      </ReactModal>
    </Fragment>
  );
}

export default InfoProgramacionHoraria;
